var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.193 38.807 0 25 0C11.193 0 0 11.193 0 25C0 37.4781 9.14219 47.8209 21.0938 49.6963V32.2266H14.7461V25H21.0938V19.4922C21.0938 13.2266 24.8262 9.76562 30.5367 9.76562C33.2719 9.76562 36.1328 10.2539 36.1328 10.2539V16.4062H32.9805C29.8748 16.4062 28.9062 18.3334 28.9062 20.3105V25H35.8398L34.7314 32.2266H28.9062V49.6963C40.8578 47.8209 50 37.4783 50 25Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2432 32.2266L35.3516 25H28.418V20.3105C28.418 18.3332 29.3865 16.4062 32.4922 16.4062H35.6445V10.2539C35.6445 10.2539 32.7836 9.76562 30.0482 9.76562C24.3379 9.76562 20.6055 13.2266 20.6055 19.4922V25H14.2578V32.2266H20.6055V49.6963C21.8977 49.8988 23.2037 50.0003 24.5117 50C25.8197 50.0004 27.1258 49.8988 28.418 49.6963V32.2266H34.2432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFacebook);
export default __webpack_public_path__ + "static/media/logos_facebook.8209aca1dcb5dca8029c56c07c4d18de.svg";
export { ForwardRef as ReactComponent };